module.exports = __webpack_public_path__ + "img/undraw_Working_oh83.ec43c9b6.svg";